

export const systemTheme = {
    colors:{
        bgColor:"#CC1821",
        bgColorLight:"#dcefff",
        txtColor:"#fff"
    }
}